export const MODIFY_NAVBAR_ITEM_CLICKED = 'MODIFY_NAVBAR_ITEM_CLICKED';

export function modifyNavbarItemClicked(navbarItemClicked){
    return{
        type: MODIFY_NAVBAR_ITEM_CLICKED,
        mainState: {
            navbarItemClicked: navbarItemClicked
        }
    }
}